<template>
  <section class="main products-mainline" v-if="isReady">
    <div class="circle1"></div>
    <div class="circle2"></div>

    <h2>
      <template v-if="productsTitleSvoyBreak">
        {{ productsTitleSvoyBreak.before }}<br class="mobile-only" />
        {{ productsTitleSvoyBreak.after }}
      </template>
      <template v-else>{{ products.attributes.title }}</template>
    </h2>

    <div class="main__items">
      <div class="main__item main__item--grid-mob" @click="$modal.show('product-1')">
        <div class="main__item-decors" aria-hidden="true">
          <div class="main__item-decor main__item-decor--1">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.decor1.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.decor1.desk">
              <img :src="decorAssets.decor1.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--2">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.decor2.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.decor2.desk">
              <img :src="decorAssets.decor2.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--3">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit1.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit1.desk">
              <img :src="decorAssets.furit1.mob" alt="">
            </picture>
          </div>
        </div>
        <div class="main__item-mob img-w">
          <img :src="imgDeskOrange" alt="">
        </div>
        <div class="main__item-desk img-w">
          <img :src="imgDeskOrange" alt="">
        </div>
        <div class="main__anim-box" v-in-viewport>
          <div class="anim__bg img-w">
            <img src="@/assets/img/prod1/bg.png" alt="" />
          </div>
          <div class="anim__piece1 img-w">
            <img src="@/assets/img/prod1/piece1.png" alt="" />
          </div>
          <div class="anim__piece2 img-w">
            <img src="@/assets/img/prod1/piece2.png" alt="" />
          </div>
          <div class="anim__bottle img-w">
            <img src="@/assets/img/prod1/bottle.png" alt="" />
          </div>
        </div>
        <h3 class="main__product-title">Апельсин</h3>
      </div>

      <div class="main__item main__item--grid-mob" @click="$modal.show('product-2')">
        <div class="main__item-decors" aria-hidden="true">
          <div class="main__item-decor main__item-decor--1">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit2.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.decor2.desk">
              <img :src="decorAssets.furit2.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--2">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit2.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit1.desk">
              <img :src="decorAssets.furit2.mob" alt="">
            </picture>
          </div>
        </div>
        <div class="main__item-mob img-w">
          <img :src="imgDeskTropical" alt="">
        </div>
        <div class="main__item-desk img-w">
          <img :src="imgDeskTropical" alt="">
        </div>
        <div class="main__anim-box" v-in-viewport>
          <div class="anim__bg anim__bg--2 img-w">
            <img src="@/assets/img/prod2/bg.png" alt="" />
          </div>
          <div class="anim__piece1 anim__piece1--2 img-w">
            <img src="@/assets/img/prod2/piece1.png" alt="" />
          </div>
          <div class="anim__piece2 anim__piece2--2 img-w">
            <img src="@/assets/img/prod2/piece2.png" alt="" />
          </div>
          <div class="anim__bottle img-w">
            <img src="@/assets/img/prod2/bottle.png" alt="" />
          </div>
        </div>
        <h3 class="main__product-title">Тропический</h3>
      </div>

      <div class="main__item new-item main__item--grid-mob" @click="$modal.show('product-6')">
        <div class="main__item-decors" aria-hidden="true">
          <div class="main__item-decor main__item-decor--1">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit3.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit3.desk">
              <img :src="decorAssets.furit3.mob" alt="">
            </picture>
          </div>
        </div>
        <div class="main__item-mob img-w">
          <img :src="imgDeskCherry" alt="">
        </div>
        <div class="main__item-desk img-w">
          <img :src="imgDeskCherry" alt="">
        </div>
        <div class="main__anim-box" v-in-viewport>
          <div class="anim__bg anim__bg--6 img-w">
            <img src="@/assets/img/prod6/bg.png" alt="" />
          </div>
          <div class="anim__piece1 anim__piece1--6 img-w">
            <img src="@/assets/img/prod6/piece1.png" alt="" />
          </div>
          <div class="anim__bottle anim__bottle--6 img-w">
            <img src="@/assets/img/prod6/bottle.png" alt="" />
          </div>
        </div>
        <h3 class="main__product-title">Вишня</h3>
      </div>

      <div class="main__item main__item--grid-mob" @click="$modal.show('product-4')">
        <div class="main__item-decors" aria-hidden="true">
          <div class="main__item-decor main__item-decor--1">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit4.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit4.desk">
              <img :src="decorAssets.furit4.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--2">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit5.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit5.desk">
              <img :src="decorAssets.furit5.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--3">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit6.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit6.desk">
              <img :src="decorAssets.furit6.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--4">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit7.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit7.desk">
              <img :src="decorAssets.furit7.mob" alt="">
            </picture>
          </div>
          <div class="main__item-decor main__item-decor--5">
            <picture>
              <source media="(max-width: 767px)" :srcset="decorAssets.furit8.mob">
              <source media="(min-width: 768px)" :srcset="decorAssets.furit8.desk">
              <img :src="decorAssets.furit8.mob" alt="">
            </picture>
          </div>
        </div>
        <div class="main__item-mob img-w">
          <img :src="imgDeskPineappleMango" alt="">
        </div>
        <div class="main__item-desk img-w">
          <img :src="imgDeskPineappleMango" alt="">
        </div>
        <div class="main__anim-box" v-in-viewport>
          <div class="anim__bg anim__bg--4 img-w">
            <img src="@/assets/img/prod4/bg.png" alt="" />
          </div>
          <div class="anim__piece1 anim__piece1--4 img-w">
            <img src="@/assets/img/prod4/piece1.png" alt="" />
          </div>
          <div class="anim__piece2 anim__piece2--4 img-w">
            <img src="@/assets/img/prod4/piece2.png" alt="" />
          </div>
          <div class="anim__bottle img-w">
            <img src="@/assets/img/prod4/bottle.png" alt="" />
          </div>
        </div>
        <h3 class="main__product-title">Ананас-манго</h3>
      </div>
    </div>

    <modal
      v-for="product in list"
      :key="product.id"
      :name="`product-${product.order}`"
      :scrollable="true"
      height="auto"
      :classes="getModalClasses(product)"
    >
      <div class="modal__close img-w" @click="$modal.hide(`product-${product.order}`)">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z"
            fill="white"
          />
        </svg>
      </div>

      
      <div v-if="isRedesignModal(product)" class="modal__df modal__df--product-redesign">
        <div
          v-if="hasProductHeroImage(product)"
          class="modal__hero-bg img-w"
          aria-hidden="true"
        >
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="getProductHeroBgUrl(product, 'mob')"
            >
            <img
              :src="getProductHeroBgUrl(product, 'desk')"
              alt=""
            >
          </picture>
        </div>
        <div class="modal__content-layer">
          <div class="modal__column">
            <h3 class="modal__title">
              {{ product.title | typograf }}
            </h3>
            <div class="modal__volume">
              <span class="modal__part-title">Объем: </span>
              <img
                v-if="getProductVolumeImageUrl(product)"
                class="modal__volume-img img-w"
                :src="getProductVolumeImageUrl(product)"
                alt=""
              >
            </div>
            <p class="modal__descr">
              {{ product.description | typograf }}
            </p>
            <div class="modal__ingr">
              <span class="modal__part-title">Ингредиенты*</span>
            </div>
            <div class="modal__content-columns modal__content-columns--product-redesign">
              <ul class="modal__ingr-list">
                <li v-for="item in getProductIngrs(product)" :key="item.id">
                  <span class="icon img-w">
                    <img
                      v-if="getIngredientMediaUrl(item)"
                      :src="getIngredientMediaUrl(item)"
                      alt=""
                    >
                  </span>
                  <span class="modal__ingr-text">{{ item.attributes.title }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal__note modal__note--mob">* Полный состав см на этикетке продукции</div>
        </div>
      </div>

      <div v-else class="modal__df">
        <div class="modal__img img-w">
          <picture v-if="hasProductHeroImage(product)">
            <source
              media="(max-width: 767px)"
              :srcset="getProductHeroBgUrl(product, 'mob')"
            >
            <img
              :src="getProductHeroBgUrl(product, 'desk')"
              alt=""
            >
          </picture>
          <img v-if="!hasProductHeroImage(product) && product.id == 6" src="@/assets/img/prod2.png" alt="" />
          <img v-if="!hasProductHeroImage(product) && product.id == 4" src="@/assets/img/prod4/prod4.png" alt="" />
          <div class="modal__note modal__note--mob">* Полный состав см на этикетке продукции</div>
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            {{ product.title | typograf }}
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span>
            <img
              v-if="getProductVolumeImageUrl(product)"
              class="modal__volume-img img-w"
              :src="getProductVolumeImageUrl(product)"
              alt=""
            >
          </div>
          <p class="modal__descr">
            {{ product.description | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li v-for="item in product.ingrs.data" :key="item.id">
                <span class="icon img-w">
                  <img
                    v-if="getIngredientMediaUrl(item)"
                    :src="getIngredientMediaUrl(item)"
                    alt=""
                  >
                </span>
                <span class="modal__ingr-text">{{ item.attributes.title }}</span>
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li v-for="item in product.ingrs2.data" :key="item.id">
                <span class="icon img-w">
                  <img
                    v-if="getIngredientMediaUrl(item)"
                    :src="getIngredientMediaUrl(item)"
                    alt=""
                  >
                </span>
                <span class="modal__ingr-text">{{ item.attributes.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ModalFooter
        :id="product.order"
        :metro="product.metroLink"
        :selgros="product.selgrosLink"
        show-composition-note
      />
    </modal>

    <!--<modal name="product-1" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-1')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/1.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            Pulpy Апельсин
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л, 0,9л
          </div>
          <p class="modal__descr">
            {{ 'Встряхни Pulpy Апельсин и открой для себя вкусный микс натурального апельсинового сока, артезианской воды и мякоти цитрусовых' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--orange"></span>
                Апельсиновый сок
              </li>
              <li>
                <span class="icon icon--orange"></span>
                Мякость апельсина
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>

    <modal name="product-2" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-2')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/2.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            Pulpy Тропический
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л, 0,9л
          </div>
          <p class="modal__descr">
            {{ 'Встряхни Pulpy Тропический и открой для себя вкусный микс сока тропических фруктов, артезианской воды и натуральной мякоти цитрусовых' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--apple"></span>
                Яблочный сок
              </li>
              <li>
                <span class="icon icon--grape"></span>
                Виноградный сок
              </li>
              <li>
                <span class="icon icon--orange"></span>
                Апельсиновый сок
              </li>
              <li>
                <span class="icon icon--tangerine"></span>
                Мандариновый сок
              </li>
              <li>
                <span class="icon icon--banana"></span>
                Банановое пюре
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--kiwi"></span>
                Сок из киви
              </li>
              <li>
                <span class="icon icon--pinapple"></span>
                Ананасовый сок
              </li>
              <li>
                <span class="icon icon--orange"></span>
                Мякость апельсина
              </li>
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>

    <modal name="product-3" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-3')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/3.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            {{ 'Pulpy Гуава-маракуйя с кусочками кокосового желе' | typograf }}
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л
          </div>
          <p class="modal__descr">
            {{ 'Встряхни Pulpy Гуава-Маракуйя и открой для себя необычное сочетание тропических фруктов и кусочков кокосового желе' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--orange"></span>
                Апельсиновый сок
              </li>
              <li>
                <span class="icon icon--apple"></span>
                Яблочное пюре
              </li>
              <li>
                <span class="icon icon--guava"></span>
                Пюре из гуавы
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--kuja"></span>
                Сок из маракуйи
              </li>
              <li>
                <span class="icon icon--coconut"></span>
                Кусочки кокосового желе
              </li>
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>

    <modal name="product-4" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-4')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/4.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            {{ 'Pulpy ананас-манго с кусочками ананаса' | typograf }}
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л
          </div>
          <p class="modal__descr">
            {{ 'Встряхни Pulpy Ананас-Манго и открой для себя удивительное сочетание натуральных кусочков ананаса, сока фруктов и артезианской воды ' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--pinapple"></span>
                Ананасовый сок
              </li>
              <li>
                <span class="icon icon--mango"></span>
                Пюре из манго
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--pinapple"></span>
                Кусочки ананаса
              </li>
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>

    <modal name="product-5" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-5')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/5.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            {{ 'Pulpy Клубника-арбуз с кусочками алоэ' | typograf }}
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л
          </div>
          <p class="modal__descr">
            {{ 'Встряхни Pulpy Клубника-Арбуз и открой для себя необыкновенное сочетание сочных фруктов, артезианской воды и натуральных кусочков алоэ' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--apple"></span>
                Яблочный сок
              </li>
              <li>
                <span class="icon icon--watermelon"></span>
                Арбузный сок
              </li>
              <li>
                <span class="icon icon--strawberry"></span>
                Клубничный сок
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--aloe"></span>
                Кусочки алоэ
              </li>
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>

    <modal name="product-6" :scrollable="true" height="auto">
      <div class="modal__close img-w" @click="$modal.hide('product-6')">
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5748 22.0092L22.1767 26.4073L39.7693 44L22.1767 61.5927L26.5748 65.9908L44.1675 48.3982L61.7602 65.9908L66.1583 61.5927L48.5657 44L66.1583 26.4073L61.7602 22.0092L44.1675 39.6018L26.5748 22.0092Z" fill="white"/>
        </svg>
      </div>

      <div class="modal__df">
        <div class="modal__img img-w">
          <img src="@/assets/img/main/6.png" alt="">
        </div>
        <div class="modal__column">
          <h3 class="modal__title">
            Pulpy австралия <br> с кусочками алоэ
          </h3>
          <div class="modal__volume">
            <span class="modal__part-title">Объем: </span> 0,45л
          </div>
          <p class="modal__descr">
            {{ 'Открой вкус Австралии!' | typograf }} <br>
            {{ 'Встречай новый освежающий Pulpy с необычным сочетанием сочного киви, кусочков алоэ и ароматом экзотической гуанабаны' | typograf }}
          </p>
          <div class="modal__ingr">
            <span class="modal__part-title">Ингредиенты*</span>
          </div>
          <div class="modal__content-columns">
            <ul class="modal__ingr-list">
              <li>
                <span class="icon icon--apple"></span>
                Яблочный сок
              </li>
              <li>
                <span class="icon icon--grape"></span>
                Виноградный сок
              </li>
              <li>
                <span class="icon icon--kiwi"></span>
                Сок киви
              </li>
            </ul>
            <ul class="modal__ingr-list modal__ingr-list--2nd">
              <li>
                <span class="icon icon--aloe"></span>
                Кусочки алоэ
              </li>
              <li>
                <span class="icon icon--water"></span>
                Артезианская вода
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalFooter />

    </modal>-->
  </section>
</template>

<script>
import ModalFooter from '../ModalFooter/ModalFooter';
// Моб. *-mob.png в репозитории были идентичны одному общему макету; в карточках используем уникальные product-*.png
import imgDeskOrange from '@/assets/img/redesign_may_2026/product-orange.png';
import imgDeskTropical from '@/assets/img/redesign_may_2026/product-tropical.png';
import imgDeskCherry from '@/assets/img/redesign_may_2026/product-cherry.png';
import imgDeskPineappleMango from '@/assets/img/redesign_may_2026/product-pineapple-mango.png';
import detailsOrangeVolume from '@/assets/img/redesign_may_2026/details-orange-volume.png';
import detailsTropicalVolume from '@/assets/img/redesign_may_2026/details-tropical-volume.png';
import detailsPineappleMangoVolume from '@/assets/img/redesign_may_2026/details-pineapple-mango-volume.png';
import decor1Mob from '@/assets/img/redesign_may_2026/decor-1-mob.png';
import decor2Mob from '@/assets/img/redesign_may_2026/decor-2-mob.png';
import furitDecor1Mob from '@/assets/img/redesign_may_2026/furit-decor-1-mob.png';
import furitDecor2Mob from '@/assets/img/redesign_may_2026/furit-decor-2-mob.png';
import furitDecor3Mob from '@/assets/img/redesign_may_2026/furit-decor-3-mob.png';
import furitDecor4Mob from '@/assets/img/redesign_may_2026/furit-decor-4-mob.png';
import furitDecor5Mob from '@/assets/img/redesign_may_2026/furit-decor-5-mob.png';
import furitDecor6Mob from '@/assets/img/redesign_may_2026/furit-decor-6-mob.png';
import furitDecor7Mob from '@/assets/img/redesign_may_2026/furit-decor-7-mob.png';
import furitDecor8Mob from '@/assets/img/redesign_may_2026/furit-decor-8-mob.png';

// Десктоп: *.png без -mob (пока fallback на mob, если файла нет)
import decor1Desk from '@/assets/img/redesign_may_2026/choice-orange.png';
import decor2Desk from '@/assets/img/redesign_may_2026/choice-kiwi.png';
import furitDecor1Desk from '@/assets/img/redesign_may_2026/choice-kiwi-decor.png';
import furitDecor2Desk from '@/assets/img/redesign_may_2026/furit-decor-2-mob.png';
import furitDecor3Desk from '@/assets/img/redesign_may_2026/furit-decor-3-mob.png';
import furitDecor4Desk from '@/assets/img/redesign_may_2026/mango-decor-1.png';
import furitDecor5Desk from '@/assets/img/redesign_may_2026/mango-decor-2.png';
import furitDecor6Desk from '@/assets/img/redesign_may_2026/furit-decor-6-mob.png';
import furitDecor7Desk from '@/assets/img/redesign_may_2026/furit-decor-7-mob.png';
import furitDecor8Desk from '@/assets/img/redesign_may_2026/furit-decor-8-mob.png';

const REDESIGN_MODAL_ORDERS = [1, 2, 4, 6];

const decorAssets = {
  decor1: { mob: decor1Mob, desk: decor1Desk },
  decor2: { mob: decor2Mob, desk: decor2Desk },
  furit1: { mob: furitDecor1Mob, desk: furitDecor1Desk },
  furit2: { mob: furitDecor2Mob, desk: furitDecor2Desk },
  furit3: { mob: furitDecor3Mob, desk: furitDecor3Desk },
  furit4: { mob: furitDecor4Mob, desk: furitDecor4Desk },
  furit5: { mob: furitDecor5Mob, desk: furitDecor5Desk },
  furit6: { mob: furitDecor6Mob, desk: furitDecor6Desk },
  furit7: { mob: furitDecor7Mob, desk: furitDecor7Desk },
  furit8: { mob: furitDecor8Mob, desk: furitDecor8Desk },
};

export default {
  name: 'ProductsMainline',
  components: { ModalFooter },
  data() {
    return {
      isReady: false,
      decorAssets,
      imgDeskOrange,
      imgDeskTropical,
      imgDeskCherry,
      imgDeskPineappleMango,
      productVolumeImages: {
        1: detailsOrangeVolume,
        2: detailsTropicalVolume,
        4: detailsPineappleMangoVolume,
      },
    };
  },
  computed: {
    products() {
      return this.$store.getters.products;
    },
    list() {
      const products = this.$store.getters.products;

      return (products && products.attributes && products.attributes.product) || [];
    },
    staticUrl() {
      return this.$store.getters.staticUrl;
    },
    productsTitleSvoyBreak() {
      const t = this.products && this.products.attributes && this.products.attributes.title;
      if (!t || typeof t !== 'string') return null;
      const i = t.indexOf('СВОЙ');
      if (i <= 0) return null;
      return {
        before: t.slice(0, i).replace(/\s+$/, ''),
        after: t.slice(i).replace(/^\s*/, ''),
      };
    },
  },

  methods: {
    isRedesignModal(product) {
      return REDESIGN_MODAL_ORDERS.includes(product.order);
    },
    getModalClasses(product) {
      if (!this.isRedesignModal(product)) {
        return '';
      }

      return `modal--product-redesign modal--product-${product.order}`;
    },
    resolveMediaPath(path) {
      if (!path) {
        return null;
      }

      if (/^https?:\/\//i.test(path)) {
        return path;
      }

      const base = (this.staticUrl || '').replace(/\/$/, '');
      const normalizedPath = path.startsWith('/') ? path : `/${path}`;

      return `${base}${normalizedPath}`;
    },
    getProductMediaUrl(product, field) {
      const media = product && product[field];

      if (!media || !media.data || !media.data.attributes) {
        return null;
      }

      return this.resolveMediaPath(media.data.attributes.url);
    },
    getProductVolumeImageUrl(product) {
      if (product && this.productVolumeImages[product.order]) {
        return this.productVolumeImages[product.order];
      }

      return this.getProductMediaUrl(product, 'volumeImage');
    },
    hasProductHeroImage(product) {
      return !!(
        this.getProductMediaUrl(product, 'fullImage') ||
        this.getProductMediaUrl(product, 'fullImageMob')
      );
    },
    getProductHeroBgUrl(product, variant) {
      const desktop = this.getProductMediaUrl(product, 'fullImage');
      const mobile = this.getProductMediaUrl(product, 'fullImageMob');

      if (variant === 'mob') {
        return mobile || desktop;
      }

      return desktop || mobile;
    },
    getIngredientMediaUrl(item) {
      const icon = item && item.attributes && item.attributes.icon;

      if (!icon || !icon.data || !icon.data.attributes) {
        return null;
      }

      return this.resolveMediaPath(icon.data.attributes.url);
    },
    getProductIngrs(product) {
      return product.ingrs && product.ingrs.data ? product.ingrs.data : [];
    },
  },

  async mounted() {
    await this.$store.dispatch('getProducts');
    this.isReady = true;
  },
};
</script>

<style scoped lang="scss">
@import 'products';
@import 'anim';
</style>

<style lang="scss">
// Декор без scoped: псевдо + background из scoped-импорта; якорь 1×1px + top/left у псевдо
.products-mainline.main {
  overflow: visible;
  isolation: isolate;
  z-index: 1;
}

.products-mainline.main .circle1,
.products-mainline.main .circle2 {
  position: absolute;
  pointer-events: none;
  z-index: 0;
  overflow: visible;
  width: 1px;
  height: 1px;
}

.products-mainline.main .circle1 {
  top: -2rem;
  left: -2rem;

  @media (max-width: 767px) {
    top: 0;
    left: -4rem;
    transform: scale(0.38);
    transform-origin: top left;
  }
}

.products-mainline.main .circle1::before,
.products-mainline.main .circle1::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.products-mainline.main .circle1::before {
  width: 30rem;
  height: 30rem;
  background-image: url('~@/assets/img/redesign_may_2026/choice-orange.png');
  transform: translate(0, 0);
}

.products-mainline.main .circle1::after {
  width: 20rem;
  height: 20rem;
  background-image: url('~@/assets/img/redesign_may_2026/choice-orange.png');
  transform: translate(10rem, 14rem) rotate(-6deg);
  opacity: 0.92;
}

.products-mainline.main .circle2 {
  right: 0;
  bottom: 8%;

  @media (max-width: 767px) {
    right: -6rem;
    bottom: 4%;
    transform: scale(0.36);
    transform-origin: bottom right;
  }
}

.products-mainline.main .circle2::before,
.products-mainline.main .circle2::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.products-mainline.main .circle2::before {
  width: 36rem;
  height: 36rem;
  background-image: url('~@/assets/img/redesign_may_2026/choice-kiwi-decor.png');
  transform: translate(-22rem, -10rem);
}

.products-mainline.main .circle2::after {
  width: 24rem;
  height: 24rem;
  background-image: url('~@/assets/img/redesign_may_2026/choice-kiwi.png');
  transform: translate(-8rem, 4rem);
}
